import { travel } from 'api';

import { UpSellResponse } from 'models/upsell';

export interface UpSellRequest {
  searchId: string;
  optionId: number;
  sessionToken: string;
  DistanceRestriction?: string;
  DepartureDate: Date;
  DepartureAirport: string;
  ArrivalAirport: string;
  userId: string;
  lowestLogicalFare?: number;
  SectorsCount?: number;
}

export const getUpSellFares = async (params: UpSellRequest): Promise<UpSellResponse> => {
  try {
    const response = await travel.get('Air/AirUpSellWholeTrip', {
      params,
    });
    return response.data.data;
  } catch (error) {
    return error.data;
  }
};
